import { Alert } from "@mui/material";

import "./AlertComponent.css";

const AlerComponent = (props) => {
  const { icon, message, type } = props;
  return (
    <Alert icon={icon} className='alert-component' severity={type}>
      <p className='text-sm'>{message}</p>
    </Alert>
  );
};

export default AlerComponent;
